import { connect } from 'react-redux'
import { notifyActions, preferencesActions } from '../store/actions';
import pageVpnSetting from './pages/vpnSetting';

const mapStateToProps = state => {
    return {
        ...state,
        preferences: state.preferences,
        role: state.role,
        user: state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendEditPreferences: (id, data) => {
            dispatch(preferencesActions.sendEditPreferences(id, data))
        },
        deleteKeyFromList: (id, key) => {
            dispatch(preferencesActions.deleteKeyFromList(id, key))
        },
        successNotify: (message) => {
            dispatch(notifyActions.successAction(message))
        },
        warningNotify: (message) => {
            dispatch(notifyActions.warningAction(message))
        },
        errorNotify: (message) => {
            dispatch(notifyActions.errorAction(message))
        },
        infoNotify: (message) => {
            dispatch(notifyActions.infoAction(message))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageVpnSetting);